import { Donvi } from './donvi';
import { Dmchuyende } from './dmchuyende';
export class Dscauhoi {
    id: number;
    ma: String;
    ten: string;
    ghichu: string;
    congkhai: number;
    isactive: number;
    createddate: Date;
    createdbyuserid: number;
    modifiedbyuserid: number;
    modifieddate: Date;  
    ngaytao: Date;
    iddonvi: number;
    dmdonvi: Donvi;
    idchuyende: number;
    dmchuyende: Dmchuyende;
    donvi: string;
    tenchuyende: string;
    tendonvi: string;
   }